<template>
  <span class="text-tenant hover:text-tenant/80 text-sm font-semibold"
    ><slot></slot
  ></span>
</template>
